import React from "react";
import GaugeChart from "react-gauge-chart";

const Meter = ({
  cornerRadius = 10,
  colors = ["#FC555B", "#F7A64F", "#1BBB6B"],
  needleColor = "#161616",
  needleBaseColor = "#161616",
  hideText = true,
  percent = 685 / 1000,
  needleScale = 0.25,
  arcWidth = 0.1,
  marginInPercent = 0.03,
  textColor = "black",
  meterWidth,
}) => {
  return (
    <>
      <GaugeChart
        id="gauge-chart1"
        cornerRadius={cornerRadius}
        colors={colors}
        needleColor={needleColor}
        needleBaseColor={needleBaseColor}
        textColor={textColor}
        hideText={hideText}
        percent={percent}
        needleScale={needleScale}
        arcWidth={arcWidth}
        marginInPercent={marginInPercent}
        style={{ width: meterWidth }}
      />
    </>
  );
};

export default Meter;
